import makeTypeCreator from '@/models/makeTypeCreator'

const createType = makeTypeCreator('coupons')
export const TOGGLE_LOADING = createType('TOGGLE_LOADING')
export const FETCH_LIST = createType('FETCH_LIST')
export const TENANT_COUPON_FETCHED = createType('TENANT_COUPON_FETCHED')
export const SHOW_INFO_DIALOG = createType('SHOW_INFO_DIALOG')
export const SHOW_COUPON_STATS_DIALOG = createType('SHOW_COUPON_STATS_DIALOG')